<script>
import TestForm from "./TestForm.vue";
import { api } from 'JIX/utils.js';

export default {
    components: {
        TestForm,
    },
    props: {
        questions: {
            type: Object,
            required: true,
        },
        resultUrl: {
            type: String,
            required: true,
        }
    },
    methods: {
        async addAnswer(answer) {
            this.answers.push(answer);
            this.histogram[answer]++;

            const answered = this.answers.length < 10 ? `0${this.answers.length}` : this.answers.length;
            window.jixAnalytics('event', { category: 'persontypetest', action: 'click', label: `svar spm. ${answered}` });

            if (this.undeterminedDims.length === 0) {
                window.jixAnalytics('event', { category: 'persontypetest', action: 'click', label: 'fuldført' });

                const resp = await api('POST', this.resultUrl, this.histogram);
                window.location.href = resp.url;
            }
        },
        removeAnswer() {
            const outcome = this.answers.pop();
            this.histogram[outcome]--;

            const removedAnswer = this.answers.length + 1 < 10 ? `0${this.answers.length + 1}` : this.answers.length + 1;
            window.jixAnalytics('event', { category: 'persontypetest', action: 'click', label: `fortryd svar på spm. ${removedAnswer}` });
        },
    },
    computed: {
        /* The algorithm for determing if a dimension is determined was given by Fredi Falk Vogelius.
           A dimension is determined if:
            * If 4 out of the 4 first, or 6 out of the 8 first dimmension questions are answered similarily
            * If all questions are answered
        */
        undeterminedDims: function() {
            const h = this.histogram;
            const q = this.questions;

            function undetermined(dim) {
                const [c1, c2] = dim;

                return !(
                    (h[c1] + h[c2] === 4 && Math.max(h[c1], h[c2]) === 4) ||
                    (h[c1] + h[c2] === 8 && Math.max(h[c1], h[c2]) >= 6) ||
                    h[c1] + h[c2] === q[dim].length
                );
            }

            return ["EI", "SN", "TF", "JP"].filter(undetermined);
        },
        activeQuestion: function() {
            const dim = this.undeterminedDims[0];

            const answered = this.histogram[dim[0]] + this.histogram[dim[1]];

            return this.questions[dim][answered];
        },
        progress: function() {
            let answered = 0;

            for (let dim of this.undeterminedDims) {
                answered =
                    answered + this.histogram[dim[0]] + this.histogram[dim[1]];
            }

            answered = answered + 11 * (4 - this.undeterminedDims.length);
            return {
                answered,
                total: 4 * 11,
            };
        },

    },
    data() {
        return {
            answers: [],
            histogram: { I: 0, E: 0, S: 0, N: 0, T: 0, F: 0, J: 0, P: 0 },
        };
    },
};
</script>

<template>
    <TestForm
        v-if="undeterminedDims.length != 0"
        :question="activeQuestion"
        :progress="progress"
        @add-answer="addAnswer"
        @remove-answer="removeAnswer"
    />

    <div v-else class="d-flex" style="min-height: 768px">
        <div class="mx-auto my-auto">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
</template>
